import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CardInfo from '../../../../components/CardInfo/CardInfo'
import EditAction from '../EditAction'
import {
    getInitialValues,
    validationSchema,
} from '../../../../forms/NotificationPreferencesForm'
import { useFormik } from 'formik'
import CheckBox from '../../../../components/CheckBox/CheckBox'

const Notificationpreferences = ({ user, handleSubmit }) => {
    const [isEnabledNP, setIsEnabledNP] = useState(false)

    const {
        getFieldProps,
        isSubmitting,
        setSubmitting,
        isValid,
        handleSubmit: onSubmitForm,
        values,
        setFieldValue,
    } = useFormik({
        validationSchema,
        initialValues: getInitialValues(user),
        onSubmit: formValues => {
            setSubmitting(true)
            handleSubmit &&
                handleSubmit(formValues).then(() => {
                    setSubmitting(false)
                    setIsEnabledNP(false)
                })
        },
    })

    useEffect(() => {
        // to restart the initial value if the user cancelthe edit
        if (!isEnabledNP) {
            setFieldValue('email_notifications', user?.email_notifications)
            setFieldValue('text_notifications', user?.text_notifications)
        }
    }, [isEnabledNP])

    const handleToggleField = (fieldName, value) => {
        setFieldValue(fieldName, value)
    }

    const hasDiferences =
        JSON.stringify({
            email_notifications: Boolean(user?.email_notifications),
            text_notifications: Boolean(user?.text_notifications),
        }) !==
        JSON.stringify({
            email_notifications: Boolean(values?.email_notifications),
            text_notifications: Boolean(values?.text_notifications),
        })

    const renderForm = () => {
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start">
                <p className="text-sm font-medium text-textDarkerGray mb-1">
                    How would you like us to keep you up to date?
                </p>
                <p className="text-xs font-normal text-textDarkGray">
                    We will send you important notifications about your account,
                    requests and other details.
                </p>

                <div className="flex flex-col items-start justify-start gap-y-2 mt-6">
                    <CheckBox
                        {...getFieldProps('email_notifications')}
                        onChange={val =>
                            handleToggleField('email_notifications', val)
                        }
                        defaultValue={false}
                        correctValue={true}
                        label="Via email"
                        disabled={!isEnabledNP}
                        defaultChecked={Boolean(values?.email_notifications)}
                    />
                    <CheckBox
                        {...getFieldProps('text_notifications')}
                        onChange={val =>
                            handleToggleField('text_notifications', val)
                        }
                        defaultValue={false}
                        correctValue={true}
                        label="Via text"
                        disabled={!isEnabledNP}
                        defaultChecked={Boolean(values?.text_notifications)}
                    />
                </div>
            </div>
        )
    }

    return (
        <form onSubmit={onSubmitForm} className="w-full">
            <CardInfo
                title="Notification Preferences"
                content={renderForm()}
                headerActions={[
                    <EditAction
                        setEnabled={setIsEnabledNP}
                        isValid={
                            isValid &&
                            !isSubmitting &&
                            isEnabledNP &&
                            hasDiferences
                        }
                        key="editButton"
                    />,
                ]}
            />
        </form>
    )
}

Notificationpreferences.propTypes = {
    user: PropTypes.object,
    handleSubmit: PropTypes.func,
}

export default Notificationpreferences
